import { request } from "../utils/request";
import { AxiosPromise } from "axios";

export const leadApi = {
  findAll: (params?: any): AxiosPromise<any> =>
    request({
      url: "/v1/admin/lead",
      params,
    }),
  create: (data: any): AxiosPromise<any> =>
    request({
      url: "/v1/admin/lead",
      data,
      method: "post",
    }),
  update: (id: number, data: any): AxiosPromise<any> =>
    request({
      url: `/v1/admin/lead/${id}`,
      method: "patch",
      data,
    }),
  delete: (id: number): AxiosPromise<any> =>
    request({
      url: `/v1/admin/lead/${id}`,
      method: "delete",
    }),
  solve: (id: number, data: any): AxiosPromise<any> =>
    request({
      url: `/v1/admin/lead/${id}/status`,
      method: "patch",
      data,
    }),

  updateNote: (id: number, data: any): AxiosPromise<any> =>
    request({
      url: `/v1/admin/lead/${id}/note`,
      method: "patch",
      data,
    }),
};
